import {
  Box,
  Checkbox,
  useTheme,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import FormHelperText from '../FormHelperText';
import LabeledBox from '../../special/LabeledBox';

const TypeCheckbox = ({
  field,
  dataCollection,
  errors,
  updateValidationOnChange,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  function handleChange() {
    const currentValue =
      typeof dataCollection[field.key] === 'boolean'
        ? dataCollection[field.key]
        : Boolean(parseInt(dataCollection[field.key]));

    updateValidationOnChange([field.key], !currentValue ? '1' : '0');
  }

  return (
    <LabeledBox
      className="flex flex-row items-center justify-start cursor-pointer w-full"
      sx={{ padding: '0px 3px', height: size !== 'small' ? '53px' : 'auto' }}
      onClick={field.disabled ? () => {} : handleChange}
      size={size}
    >
      <Checkbox
        size={size}
        color="secondary"
        disabled={field.disabled}
        checked={
          typeof dataCollection[field.key] === 'boolean'
            ? dataCollection[field.key]
            : Boolean(parseInt(dataCollection[field.key]))
        }
      />
      <Typography color={field.disabled ? 'text.disabled' : 'text.primary'}>
        {field.label}
      </Typography>
      <FormHelperText />
    </LabeledBox>
  );
};

export default TypeCheckbox;
